export default "__VITE_ASSET__BN_d6gAc__"